import annotations from 'emoji-annotation-to-unicode';
import emoticons from 'emoji-emoticon-to-unicode';
import assign from 'object-assign';
import * as linkify from 'linkifyjs';

// Removed from packages.json due to ES6 usage
// https://github.com/sindresorhus/escape-string-regexp
//
const escapeStringRegexp = string => {
    const matchOperatorsRegex = /[|\\{}()[\]^$+*?.-]/g;
    if (typeof string !== 'string') {
        throw new TypeError('Expected a string');
    }
    return string.replace(matchOperatorsRegex, '\\$&');
};

const getEscapedKeys = (hash) => {
    return Object.keys(hash)
        .map(x => escapeStringRegexp(x))
        .join('|');
};

const getKey = (key) => {
    if (key.match(/^:.*:$/)) {
        return key.replace(/^:/, '').replace(/:$/, '');
    } else {
        return key;
    }
};

// Use negated lookahead for `:/`, refs: https://github.com/banyan/react-emoji/issues/1
// TODO: exclude change for © ® ™
const specialEmoticons = { ':/': '1f615' };
const specialEmoticonsRegex = '\\:\\/(?!\\/)';
const excludeEmoticons = ['0:3'];

const emojiWithEmoticons = {
    delimiter: new RegExp(`(:(?:${getEscapedKeys(annotations)}):|${getEscapedKeys(emoticons)}|${specialEmoticonsRegex})`, 'g'),
    dict: assign(annotations, emoticons, specialEmoticons)
};

export const fromCodePoint = (codepoint) => {
    let code = typeof codepoint === 'string' ?
        parseInt(codepoint, 16) : codepoint;
    if (code < 0x10000) {
        return String.fromCharCode(code);
    }
    code -= 0x10000;
    return String.fromCharCode(
        0xD800 + (code >> 10),
        0xDC00 + (code & 0x3FF)
    );
};

export const emojifyText = (text) => {
    let { delimiter, dict } = emojiWithEmoticons;

    text = text.split(' ').map((word) => {
        // skip emojifying URL's
        if (linkify.find(word).length === 0) {
            word = word.split(delimiter).map((word) => {
                const match = word.match(delimiter);
                if (match && excludeEmoticons.indexOf(word) === -1) {
                    const hex = dict[getKey(match[0])];
                    if (hex === null) {
                        return word;
                    }
                    return fromCodePoint(hex);
                } else {
                    return word;
                }
            });
            return word.join('');
        }
        else {
            // pass URL unchanged
            return word;
        }
    });
    return text.join(' ');
};
